import styled from "styled-components"

export const Default = styled.div`
  font-size: 1rem;
  display: flex;
  justify-content: center;
  padding: 0 0.5rem;
  font-weight: 700;
  border-radius: 0.6rem;
  line-height: 2rem;
align-items: center;
  text-align: center;
  background: ${p => p.theme.colors.greyLighter};
  color: ${p => p.theme.colors.greyDark};
  border: 0.1rem solid${p => p.theme.colors.greyDark};
`

export const Success = styled(Default)`
  background: #dcf4e5;
  color: rgb(9, 174, 76);
  border: 0.1rem solid rgb(9, 174, 76);
`

export const Waiting = styled(Default)`
  color: #e69503;
  background: #ffedcd;
  border: 0.1rem solid #e69503;
`

export const Error = styled(Default)`
  background: #ffe6e6;
  color: #e64d4d;
  border: 0.1rem solid #e64d4d;
`
